import styled from "@emotion/styled";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import { useLoginDialogStateHelper } from "scmp-app/components/login-dialog/hooks";

import {
  ButtonWrapper,
  Container,
  Content,
  HighlightedContent,
  LoginMessage,
  LoginText,
  LoginWrapper,
  StyledButton,
  StyledLogo,
  Wrapper,
} from "./styles";

const Component: FunctionComponent = () => {
  const { openLoginDialog } = useLoginDialogStateHelper();

  const handleTryForFree = () => {
    window.open("https://subscribe.scmp.com/plus", "_blank");
  };

  const handleLoginClick = useCallback(() => {
    openLoginDialog({
      application: "scmp-plus",
      destination: window.location.href,
      ga4CustomParameter: {
        trigger_point: "plus_inline_widget",
      },
    });
  }, [openLoginDialog]);

  return (
    <Container>
      <StyledLogo />
      <Wrapper>
        <Content>
          SCMP Plus is a new premium news platform that gives you an
          <HighlightedContent>
            {" "}
            all-inclusive edge to stay ahead on China news.
          </HighlightedContent>{" "}
          To access our exclusive content you’ll need to subscribe.
        </Content>
        <ButtonWrapper>
          <StyledButton onClick={handleTryForFree}>TRY FOR FREE</StyledButton>
          <LoginWrapper>
            <LoginMessage>Already a subscriber?</LoginMessage>
            <LoginText onClick={handleLoginClick}>LOG IN</LoginText>
          </LoginWrapper>
        </ButtonWrapper>
      </Wrapper>
    </Container>
  );
};

Component.displayName = "InlinePlusWidgetNonSubscriber";

export const InlinePlusWidgetNonSubscriber = styled(Component)``;
